import React from 'react';
import { withRouter, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import store from 'root/admin/store';

import Edit from './Edit';
import List from './List';

@withRouter
@observer
export default class Tags extends React.Component {
	async componentDidMount() {
		store.ui.setPage('tags');
		console.log('getting log');
		// store.model.Tag.log();
	}

	render() {
		const path = this.props.match.path;
		const { model } = this.props;
		const rootPath = path.substring(0, path.length - 5);

		return (
			<>
				<Route exact path={`${path}`} component={() => <List model={model} rootPath={rootPath} />} />
				<Route exact path={`${path}/:id`} component={() => <Edit model={model} rootPath={rootPath} />} />
			</>
		);
	}
}
